/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function AddressBook(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M160,112a24,24,0,1,1-24-24A24.0275,24.0275,0,0,1,160,112Zm64-72V216a16.01833,16.01833,0,0,1-16,16H64a16.01833,16.01833,0,0,1-16-16V196H32a8,8,0,0,1,0-16H48V156H32a8,8,0,0,1,0-16H48V116H32a8,8,0,0,1,0-16H48V76H32a8,8,0,0,1,0-16H48V40A16.01833,16.01833,0,0,1,64,24H208A16.01833,16.01833,0,0,1,224,40ZM190.397,163.19141a67.80622,67.80622,0,0,0-27.42627-21.68067,40,40,0,1,0-53.94153-.00012,67.80949,67.80949,0,0,0-27.42858,21.68274,8,8,0,1,0,12.793,9.60937,52.0088,52.0088,0,0,1,83.21143-.00195,7.99961,7.99961,0,1,0,12.792-9.60937Z" />
    </Svg>
  );
}

export default AddressBook;
